import axios from 'axios'
import { csrfInterceptor, unauthorizedInterceptor } from './interceptor'

const httpClient = axios.create({
  withCredentials: true,
  headers: { Accept: 'application/json' },
  validateStatus: () => true,
})

httpClient.interceptors.request.use(csrfInterceptor)
httpClient.interceptors.response.use(unauthorizedInterceptor)

export default httpClient
